export var conditions = [{
  Category: 'Occurrence'
}, {
  Name: 'Exists',
  Pattern: '{0}',
  LabelPattern: '{0} exists',
  Regex: new RegExp('([^\\(\\)\\[\\]\\s]+)'),
  OperatorsNumber: 1
}, {
  Name: 'Doesn\'t Exist',
  Pattern: 'not({0})',
  LabelPattern: '{0} doesn\'t exists',
  Regex: new RegExp('not\\(([^\\(\\)\\[\\]\\s]+)\\)'),
  OperatorsNumber: 1
}, {
  Category: 'Text'
}, {
  Name: 'Equal',
  Pattern: '{0} = \'{1}\'',
  LabelPattern: '{0} is equal with {1}',
  Regex: new RegExp('([^\\(\\)\\[\\]\\s]+)\\s*=\\s*\'(.*)\''),
  OperatorsNumber: 2
}, {
  Name: 'Not Equal',
  Pattern: '{0} != \'{1}\'',
  LabelPattern: '{0} is not equal with {1}',
  Regex: new RegExp('([^\\(\\)\\[\\]\\s]+)\\s*!=\\s*\'(.*)\''),
  OperatorsNumber: 2
}, {
  Name: 'Is empty',
  Pattern: '{0} and string({0}) = \'\'',
  LabelPattern: '{0} is empty',
  Regex: new RegExp('([^\\(\\)\\[\\]\\s]+)\\s*and\\s*string\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*=\\s*\'\''),
  OperatorsNumber: 2,
  SameOperators: true
}, {
  Name: 'Is not empty',
  Pattern: 'string({0}) != \'\'',
  LabelPattern: '{0} is not empty',
  Regex: new RegExp('string\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*!=\\s*\'\''),
  OperatorsNumber: 1
}, {
  Name: 'Doesn\'t exist or is empty',
  Pattern: 'string({0}) = \'\'',
  LabelPattern: '{0} doesn\'t exist or is empty',
  Regex: new RegExp('string\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*=\\s*\'\''),
  OperatorsNumber: 1
}, {
  Name: 'Contains',
  Pattern: 'contains({0},\'{1}\')',
  LabelPattern: '{0} contains {1}',
  Regex: new RegExp('contains\\(([^\\(\\)\\[\\]\\s]+)\\s*,\\s*\'(.*)\'\\)\\s*'),
  OperatorsNumber: 2
}, {
  Name: 'Starts With',
  Pattern: 'starts-with({0},\'{1}\')',
  LabelPattern: '{0} starts with {1}',
  Regex: new RegExp('starts-with\\(([^\\(\\)\\[\\]\\s]+)\\s*,\\s*\'(.*)\'\\)\\s*'),
  OperatorsNumber: 2
}, {
  Category: 'Numeric'
}, {
  Name: 'Equal',
  Pattern: 'number({0}) = {1}',
  LabelPattern: '{0} is equal with {1}',
  Regex: new RegExp('number\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*=\\s*(\\S+)'),
  OperatorsNumber: 2
}, {
  Name: 'Not Equal',
  Pattern: 'number({0}) != {1}',
  LabelPattern: '{0} is not equal with {1}',
  Regex: new RegExp('number\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*!=\\s*(\\S+)'),
  OperatorsNumber: 2
}, {
  Name: 'Less than or equal to',
  Pattern: 'number({0}) <= {1}',
  LabelPattern: '{0} is less than or equal to {1}',
  Regex: new RegExp('number\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*<=\\s*(\\S+)'),
  OperatorsNumber: 2
}, {
  Name: 'Greater than or equal to',
  Pattern: 'number({0}) >= {1}',
  LabelPattern: '{0} is greater than or equal to {1}',
  Regex: new RegExp('number\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*>=\\s*(\\S+)'),
  OperatorsNumber: 2
}, {
  Name: 'Less than',
  Pattern: 'number({0}) < {1}',
  LabelPattern: '{0} is less than {1}',
  Regex: new RegExp('number\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*<\\s*(\\S+)'),
  OperatorsNumber: 2
}, {
  Name: 'Greater than',
  Pattern: 'number({0}) > {1}',
  LabelPattern: '{0} is greater than {1}',
  Regex: new RegExp('number\\(([^\\(\\)\\[\\]\\s]+)\\)\\s*>\\s*(\\S+)'),
  OperatorsNumber: 2
}];
export var parseExpression = function parseExpression(expression) {
  for (var expressionIdx = conditions.length - 1; expressionIdx >= 0; expressionIdx--) {
    var condition = conditions[expressionIdx];

    if (condition.OperatorsNumber == 2) {
      var result = condition.Regex.exec(expression);
      if (!result || result.length != 3 || result[0] !== expression) continue; // in case we need same operators value, continue to search when different

      if (condition.SameOperators && result[1] != result[2]) continue;
      if (condition.SameOperators) return {
        Condition: condition,
        Expression: expression,
        FirstOperator: result[1]
      };
      return {
        Condition: condition,
        Expression: expression,
        FirstOperator: result[1],
        SecondOperator: result[2]
      };
    }

    if (condition.OperatorsNumber == 1) {
      var _result = condition.Regex.exec(expression);

      if (!_result || _result.length != 2 || _result[0] !== expression) continue;
      return {
        Condition: condition,
        Expression: expression,
        FirstOperator: _result[1]
      };
    }
  }
};
export var getExpression = function getExpression(condition, path, operator) {
  if (!path) return null;
  if (condition.OperatorsNumber == 2 && !condition.SameOperators && !operator) return null;
  return condition.Pattern.replace('{0}', path).replace('{1}', operator);
};
export var isAdvancedExpression = function isAdvancedExpression(expression) {
  return ['+', '*', '!', '=', '<', '>', '[', ']', '{', '}', '(', ')'].some(function (char) {
    return expression.indexOf(char) > -1;
  });
};